export var WebFsInitLogType;
(function (WebFsInitLogType) {
    WebFsInitLogType["START"] = "webfs_init-start";
    WebFsInitLogType["SUCCESS"] = "webfs_init-success";
    WebFsInitLogType["FAILURE"] = "webfs_init-failure";
    WebFsInitLogType["TEAR_DOWN_ERROR"] = "webfs_init-tear-down-error";
    WebFsInitLogType["VALIDATE_START"] = "webfs_init-validate-start";
    WebFsInitLogType["VALIDATE_SUCCESS"] = "webfs_init-validate-success";
    WebFsInitLogType["VALIDATE_ERROR"] = "webfs_init-validate-error";
    WebFsInitLogType["VALIDATE_ACCESS"] = "webfs_init-validate-permissions";
    WebFsInitLogType["VALIDATE_CLEANUP"] = "webfs_init-validate-cleanup";
})(WebFsInitLogType || (WebFsInitLogType = {}));
export var WebFsConnectionLogType;
(function (WebFsConnectionLogType) {
    WebFsConnectionLogType["CONNECT_START"] = "webfs_connection-connect-start";
    WebFsConnectionLogType["CONNECT_SUCCESS"] = "webfs_connection-connect-success";
    WebFsConnectionLogType["CONNECT_TIMEOUT"] = "webfs_connection-connect-timeout";
    WebFsConnectionLogType["RECONNECT_START"] = "webfs_connection-reconnect-start";
    WebFsConnectionLogType["RECONNECT_ATTEMPT"] = "webfs_connection-reconnect-attempt";
    WebFsConnectionLogType["RECONNECT_ABORT"] = "webfs_connection-reconnect-abort";
    WebFsConnectionLogType["DISCONNECT_START"] = "webfs_connection-disconnect-start";
    WebFsConnectionLogType["DISCONNECT_SUCCESS"] = "webfs_connection-disconnect-success";
    WebFsConnectionLogType["CONNECTION_ERROR"] = "webfs_connection-error";
    WebFsConnectionLogType["CONNECTION_LOST"] = "webfs_connection-lost";
})(WebFsConnectionLogType || (WebFsConnectionLogType = {}));
